import { render, staticRenderFns } from "./events.demo.page.vue?vue&type=template&id=54d2a9d4&"
import script from "./events.demo.page.vue?vue&type=script&lang=js&"
export * from "./events.demo.page.vue?vue&type=script&lang=js&"
import style0 from "./events.demo.page.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports